export const isInternalAdmin = (email) => {
  return (
    email.endsWith("@nfiny.com") ||
    email.includes("@zolo.")
  );
};
